module.exports = __webpack_public_path__ + "static/media/kikudoo-logo.22522490.png";